// extracted by mini-css-extract-plugin
export default {"infoIcon":"bYYCSlLRfWEtKRaseBsU","delete":"YeR9f4ob_2o2QxxOfeX3"};